import { render } from "./RedirectPage.vue?vue&type=template&id=186297ac&scoped=true"
import script from "./RedirectPage.vue?vue&type=script&lang=js"
export * from "./RedirectPage.vue?vue&type=script&lang=js"

import "./RedirectPage.vue?vue&type=style&index=0&id=186297ac&lang=scss&scoped=true"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186297ac"]])

export default __exports__